import Shape from './../components/Shape';

const drawOuterRingPart = (x, y, a, partSize, orr, orir, o, color) => {
    return Shape.create()
        .moveTo(
            x + (Math.sin(a - partSize / 2) * (orir - o)) + (Math.sin(a) * o),
            y + (Math.cos(a - partSize / 2) * (orir - o)) + (Math.cos(a) * o)
        )
        .arc(
            orir, orir,
            0, 0, 0,
            x + (Math.sin(a + partSize / 2) * (orir - o)) + (Math.sin(a) * o),
            y + (Math.cos(a + partSize / 2) * (orir - o)) + (Math.cos(a) * o)
        )
        .lineTo(
            x + (Math.sin(a + partSize / 2) * (orr - o)) + (Math.sin(a) * o),
            y + (Math.cos(a + partSize / 2) * (orr - o)) + (Math.cos(a) * o)
        )
        .arc(
            orr, orr,
            0, 0, 1,
            x + (Math.sin(a - partSize / 2) * (orr - o)) + (Math.sin(a) * o),
            y + (Math.cos(a - partSize / 2) * (orr - o)) + (Math.cos(a) * o)
        )
        .close()
        .fillColor(color)
        .element();
};

export default drawOuterRingPart;
